import { useEffect } from "react";
import { useAddApprovals, useEditApprovals, useFetchApprovals, useUpdateApprovals } from "../mutation";
import { useGetSchedule, useGetSchedules } from "../../schedulePlanning";

export const useFetchApproval = ({ stageID, projectId }: { stageID: string, projectId?: string }) => {

    const approvals = useFetchApprovals();
    const updateApproval = useUpdateApprovals();
    const addApproval = useAddApprovals();
    const editApproval = useEditApprovals();

    const { removeCache: removeGetSchedules } = useGetSchedules(Number(projectId));
    const { removeCache: removeGetSchedule } = useGetSchedule(Number(stageID));

    const fetch = async () => {
        await approvals.mutateAsync({ stageID });
    };

    const add = async (payload: { user_id: number; is_decision_gate: boolean; }) => {
        await addApproval.mutateAsync({ stageID, payload });
        await fetch();
    };

    const edit = async (id: string, payload: { user_id: number; is_decision_gate: boolean }) => {
        await editApproval.mutateAsync({ stageID, payload, approvalID: id });
        await fetch();
    };

    const update = async (approvalID: string, status: "on_hold" | "approved" | "pending", notes: null | string) => {
        const payload = { status, notes };
        await updateApproval.mutateAsync({ stageID, approvalID, payload });
        await fetch();
        removeGetSchedules();
        removeGetSchedule();
    };

    useEffect(() => {
        fetch();
    }, []);

    return {
        isUpdating: updateApproval.isPending,
        isAdding: addApproval.isPending,
        isEditing: editApproval.isPending,
        isPending: approvals.isPending,
        data: approvals.isSuccess ? approvals?.data?.data?.rows : [],
        handleUpdateApproval: update,
        handleAssignApprover: add,
        handleUpdateApprover: edit,
    };

};